export const SWITCH_NETWORK = {
  type: "switchNetwork",
  payload: false
};
